import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { AuthService, UtilsService, TasksService } from "@services";
import { SlickToastService } from "slick-components";
import { ITaskModel, TaskModel } from "@models";
import { Subscription } from "rxjs";
import { TasksStore } from "@stores";
import { TaskEditDialogComponent } from "@app/tasks/tasks-components";

/**
 * The Tasks menu in the header.  Task reminders used to be raised here as well - a toast plus a
 * separate reminder dialog hanging off this menu - but every in-app notification now goes through
 * the notification panel, so the reminder subscription lives in NotificationsComponent instead.
 */
@Component({
    selector: "tasks",
    templateUrl: "tasks.component.html",
    styleUrls: ['tasks.component.css'],
    providers: [TasksService, SlickToastService],
    standalone: false
})

export class TasksComponent implements OnInit, OnDestroy {
	@ViewChild("taskEditDialogRef") taskEditDialogRef: TaskEditDialogComponent;

	activeTasks: ITaskModel[] = [];
	showingTasks = false;

	taskCount: number;
	taskCount$: Subscription;

	showTasksButtonClicked = false;

	constructor(private authService: AuthService,
		private tasksStore: TasksStore) {
	}

	async ngOnInit() {
		if (this.authService.isAuthenticated === true)
			this.taskCount$ = this.tasksStore.taskCountSubject.subscribe(taskCount => this.taskCount = taskCount);
	}

	ngOnDestroy() {
		if (this.taskCount$)
			this.taskCount$.unsubscribe();
	}

	async addTask() {
		this.hideTaskWindow();

		const taskModel = new TaskModel();

		await this.taskEditDialogRef.showDialog(taskModel);
	}

	showTasks() {
		this.showTasksButtonClicked = true;
		if (!this.showingTasks) {
			this.showingTasks = true;
			this.activeTasks = this.tasksStore.getActiveTasks();
			document.addEventListener("click", this.fnDocumentClick);
		} else {
			this.hideTaskWindow();
		}
	}

	hideTaskWindow() {
		document.removeEventListener("click", this.fnDocumentClick, true);
		this.showingTasks = false;
	}

	private fnDocumentClick = (e) =>  {
		// If the next document click was from the toggle, let it pass once
		if (this.showTasksButtonClicked) {
			this.showTasksButtonClicked = false;
			return;
		}

		if (UtilsService.checkParentClassExists(e.target, "task-details")) {
			return;
		}

		this.hideTaskWindow();
	}

}
